import { useState } from "react";
import { authLogin, PUBLIC_APP_URL } from "./authClient";

const SignInRecovery = () => {
  const [isSigningIn, setIsSigningIn] = useState(false);
  const [retryFailed, setRetryFailed] = useState(false);

  const handleSignIn = async () => {
    setIsSigningIn(true);
    setRetryFailed(false);
    try {
      await authLogin();
    } catch {
      setRetryFailed(true);
    } finally {
      setIsSigningIn(false);
    }
  };

  return (
    <main className="flex min-h-screen items-center justify-center bg-surface-page px-6" data-testid="sign-in-recovery">
      <section className="w-full max-w-md rounded-2xl bg-white p-8 shadow-sm" aria-labelledby="sign-in-recovery-title">
        <h1 id="sign-in-recovery-title" className="text-2xl font-semibold text-text-primary">Please sign in again</h1>
        <p className="mt-4 text-text-primary">
          We couldn’t keep you signed in. Your saved dreams are unchanged.
        </p>
        {retryFailed && (
          <p role="alert" className="mt-4 text-red-700">Sign-in couldn’t start. Please try again.</p>
        )}
        <button
          type="button"
          data-testid="sign-in-recovery-button"
          onClick={handleSignIn}
          disabled={isSigningIn}
          className="mt-6 w-full rounded-lg bg-brand-primary px-4 py-3 font-semibold text-white focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 disabled:opacity-60"
        >
          {isSigningIn ? "Opening sign-in…" : "Sign in again"}
        </button>
        <a href={PUBLIC_APP_URL} className="mt-4 block text-center text-brand-primary underline">
          Back to DreamsUp
        </a>
      </section>
    </main>
  );
};

export default SignInRecovery;
